import React, { useState } from "react";
import { saveIndividualOnboarding, submitOnboarding } from "../../UrlCrud";
import Select from "react-select";
import stateList from "../../../nigeria-state-and-lgas.json";
import "./onboarding.scss";

// Individual onboarding - deliberately minimal (per explicit instruction:
// "keep individual onboarding minimal... do not force individual users
// through company verification"). Reuses existing profile fields only.
// Still goes through the SAME approval architecture as organisations
// (submits into pending_review) - Anike has always required Super Admin
// approval for every self-registration regardless of individual/company,
// and this preserves that rather than silently exempting individuals.
export default function IndividualOnboarding({ user, onSubmitted, onRefresh }) {
    const [address, setAddress] = useState(user?.address || "");
    const [telephone, setTelephone] = useState(user?.telephone || "");
    const [stateValue, setStateValue] = useState(user?.state || null);
    const [lgaValue, setLgaValue] = useState(user?.lga || null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        setSaving(true);
        setError(null);
        try {
            await saveIndividualOnboarding({ address, telephone, state: stateValue, lga: lgaValue });
            await submitOnboarding();
            onSubmitted();
        } catch (err) {
            setError(err.response && err.response.data ? (err.response.data.message || err.response.data) : "Failed to submit for review");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="onboarding-card">
            <h4 className="font-weight-bolder mb-2">A few more details</h4>
            <p className="text-muted mb-6">
                Just enough to get your account approved - nothing else is required to use Anike as an individual.
            </p>

            {error && (
                <div className="alert alert-custom alert-light-danger fade show mb-6">
                    <div className="alert-text font-weight-bold">{typeof error === "string" ? error : JSON.stringify(error)}</div>
                </div>
            )}

            <div className="form-group">
                <label>Phone number</label>
                <input className="form-control form-control-solid" value={telephone} onChange={e => setTelephone(e.target.value)} />
            </div>
            <div className="form-group">
                <label>Address</label>
                <input className="form-control form-control-solid" value={address} onChange={e => setAddress(e.target.value)} />
            </div>
            <div className="form-group">
                <label>State</label>
                <Select placeholder="Select State" options={stateList} getOptionValue={o => o["alias"]} getOptionLabel={o => o["state"]} value={stateValue} onChange={setStateValue} />
            </div>
            <div className="form-group">
                <label>LGA</label>
                <Select placeholder="LGA" options={stateValue && stateValue.lgas ? stateValue.lgas.map(p => ({ name: p, label: p })) : []} getOptionValue={o => o["name"]} getOptionLabel={o => o["label"]} value={lgaValue} onChange={setLgaValue} />
            </div>

            <div className="onboarding-footer-actions">
                <button className="btn btn-success" disabled={saving} onClick={handleSubmit}>Submit for Review</button>
            </div>
        </div>
    );
}
